export const LOG_PLOT_TRACES_LIMIT = 9;
export const FETCH_BATCH_SIZE = 10;
